import { Box, BoxProps, ModBox, Text } from '@jfs/ui-new'
import { useCallback, useRef } from 'react'
import ActionsMenu from '../../../../../components/ActionMenu/ActionsMenu'
import { useLazyApiData, useStores } from '../../../../../data/store'

interface CheckerHeaderProps {
  title: string
  fetchDataOnChange?: any
  filterVisible?: any
  setFilterVisible?: any
  filterApplied?: any
  exportFile?: any
  onSearchByEntityIdClick?: any
  showSearchByCrossButton?: any
  showSearchByLoader?: any
  showRefresh?: any
  onRefresh?: any
  showCalendar?: any
  showSearchByEntityId?: any
  enableFilter?: any
  showDownloadButton?: any
  selectedFilterData?: any
}
export const CheckerHeader = ({
  title,
  fetchDataOnChange,
  filterVisible,
  setFilterVisible,
  filterApplied,
  exportFile,
  onSearchByEntityIdClick,
  showSearchByCrossButton,
  showSearchByLoader,
  showRefresh,
  onRefresh,
  showCalendar = true,
  showSearchByEntityId = true,
  enableFilter = true,
  showDownloadButton = false,
  selectedFilterData = {},
}: CheckerHeaderProps) => {
  const { exportByJobIdAsync, selectedDateInfo } = useStores((store) => ({
    exportByJobIdAsync: store.exportByJobIdAsync,
    selectedDateInfo: store.selectedDateInfo,
  }))
  const [lazyExportFileAsync, exportFileAsyncHandler] = useLazyApiData(exportByJobIdAsync)
  const abortControllerRef = useRef<AbortController>()
  const getAbortController = () => {
    abortControllerRef.current = new AbortController()
    return abortControllerRef.current
  }

  const onDownloadPress = useCallback(() => {
    lazyExportFileAsync(selectedFilterData, getAbortController)
  }, [selectedFilterData])

  return (
    <Box {...styles.header}>
      <ModBox w={'100%'}>
        <Text title={title} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        <ActionsMenu
          fetchDataOnChange={fetchDataOnChange}
          filterVisible={filterVisible}
          setFilterVisible={setFilterVisible}
          showSearchByEntityId={showSearchByEntityId}
          enableFilter={enableFilter}
          showCalendar={showCalendar}
          defaultPage={1}
          type="aadharRedactionChecker"
          filterApplied={filterApplied}
          showExport={false}
          handleExport={exportFile}
          showSearch={false}
          showRefresh={showRefresh}
          onRefresh={onRefresh}
          onSearchByEntityIdClick={onSearchByEntityIdClick}
          showSearchByCrossButton={showSearchByCrossButton}
          showSearchByLoader={showSearchByLoader}
          searchByEntityIdPlaceholder={'Search By Application Id...'}
          showAdditionalButton={showDownloadButton}
          additionalButtonProps={{
            title: 'Download',
            onPress: onDownloadPress,
            height: '31',
            icon: 'DOWNLOAD',
            isLoading: exportFileAsyncHandler?.state === 'pending',
          }}
        />
      </ModBox>
    </Box>
  )
}

const styles = {
  header: {
    flexDirection: 'row',
    p: 16,
    w: '100%',
  } as BoxProps,
}
